module.exports = __webpack_public_path__ + "static/media/forhims.5372c933.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/receipt/ad/forhims.png
// module id = 1823
// module chunks = 0